import { BaseRouting } from '@aipb/routing';
import { Injectable } from '@angular/core';
import { ReportTesterEnvService } from '../env';

@Injectable({
  providedIn: 'root'
})
export class ReportTesterRouting extends BaseRouting {
  static APP_ROUTE = 'report-tester';

  static configPath = ':configId';

  static jsonEditorPath = 'json-editor';
  static jsonEditorDefaultPath = '';
  jsonEditor = this.createRouteSet<{
    configId?: string;
  }>([ReportTesterRouting.jsonEditorPath]);

  constructor(reportTesterEnv: ReportTesterEnvService) {
    super(['/' + ReportTesterRouting.APP_ROUTE, ReportTesterRouting.configPath], reportTesterEnv);
  }
}
